import { t } from "@lingui/macro";

import {
  DropdownSelect,
  SelectableTile,
} from "@whoosh/design-system/src/components/controls";
import {
  InfoBanner,
  InfoBannerInformationIcon,
} from "@whoosh/design-system/src/components/display/InfoBanner";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  currentGroupCount: number;
  maxGroupCount: number;
  setGroupCount: (count: number) => void;
};

export const MultipleSlotRequestGroupCountControl = ({
  currentGroupCount,
  maxGroupCount,
  setGroupCount,
}: Props) => {
  if (maxGroupCount <= 1 && currentGroupCount <= 1) {
    return null;
  }

  const options = Array.from({ length: maxGroupCount }, (_, index) => ({
    value: index + 1,
    label: `${index + 1} ${index === 0 ? t`Tee time` : t`Tee times`}`,
  }));

  return (
    <VStack
      testID="multiple-slot-request-group-count-control"
      gap={4}
      padding={5}
      paddingBottom={3}
      width="100%"
      backgroundColor="surface-primary"
    >
      <Text variant="mainBaseSemiBold">{t`Number of Tee Times`}</Text>
      <HStack gap={2} width="100%">
        {maxGroupCount > 4 ? (
          <Box width="100%">
            <DropdownSelect
              value={currentGroupCount}
              placeholder={t`Select Number of Tee Times`}
              testID="multiple-slot-request-group-count-dropdown"
              onChange={(value) => {
                if (value) {
                  setGroupCount(value);
                }
              }}
              options={options}
              hideOuterMargin
            />
          </Box>
        ) : (
          options.map((option) => (
            <SelectableTile
              testID={`multiple-slot-request-group-count-${option.value}`}
              isSmall
              key={option.value}
              align="center"
              isSelected={option.value === currentGroupCount}
              setSelected={(isSelected: boolean) => {
                if (isSelected) {
                  setGroupCount(option.value);
                }
              }}
              title={`${option.value}`}
            />
          ))
        )}
      </HStack>
      {currentGroupCount > maxGroupCount ? (
        <InfoBanner
          colorTheme="ERROR"
          leadingIcon={InfoBannerInformationIcon}
          message={t`You have ${currentGroupCount} groups, but this start time allows at most ${maxGroupCount}. Select fewer tee times or choose a different start time.`}
        />
      ) : currentGroupCount > 1 ? (
        <InfoBanner
          colorTheme="ERROR"
          leadingIcon={InfoBannerInformationIcon}
          message={t`All groups must fit within the selected play window.`}
        />
      ) : null}
    </VStack>
  );
};
